import React from "react";
export var TreeContext = React.createContext({
    selectable: false,
    activable: false,
    expandedIds: [],
    activeIds: [],
    fullExpandable: false,
});
//# sourceMappingURL=TreeContext.js.map